import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="SOCIAL MEDIA CLONE"
          des="The Social Media Clone Project replicates key features of popular platforms. Developed using HTML, CSS, and JavaScript, it provides users with a familiar interface, fostering engagement and interaction"
          src={projectOne}
        />
        <ProjectsCard
          title="E-commerce Website"
          des=" The E-commerce Website Project delivers a seamless online shopping experience. Developed with HTML, CSS, and PHP, it features secure payment gateways and efficient inventory management, ensuring a user-friendly platform for transactions.
          "
          src={projectTwo}
        />
        <ProjectsCard
          title="Chatting App"
          des=" This Web Chat Application Project Report outlines the successful implementation of a dynamic and secure platform, meeting communication needs effectively while laying the foundation for future enhancements."
          src={projectThree}
        />
        {/*
        <ProjectsCard
          title="SOCIAL MEDIA CLONE"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectThree}
        />
        <ProjectsCard
          title="E-commerce Website"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectOne}
        />
        <ProjectsCard
          title="Chatting App"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectTwo}
        />*/}
      </div>
    </section>
  );
}

export default Projects